import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let cancelled = false;
    let stop = false;

    const poll = async (n) => {
      if (cancelled || stop) return;
      if (n >= 30) { setStatus("timeout"); return; }
      setAttempts(n + 1);
      try {
        const r = await axios.get(`${API}/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); stop = true; return; }
        if (r.data.status === "expired") { setStatus("expired"); stop = true; return; }
        setTimeout(() => poll(n + 1), 2000);
      } catch (e) {
        setStatus("error");
      }
    };
    poll(0);
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <section className="container-narrow py-32 text-center" data-testid="payment-success-page">
      {status === "paid" && (
        <>
          <CheckCircle2 className="h-16 w-16 text-[hsl(var(--primary))] mx-auto" />
          <div className="overline mt-8">Pagamento confirmado</div>
          <h1 className="display-heading text-5xl mt-6">Inscrição confirmada.</h1>
          <span className="accent-rule mt-8 inline-block" />
          <p className="mt-8 text-lg text-[hsl(var(--muted-foreground))] leading-relaxed">
            Recebemos o seu pagamento. Em breve receberá o recibo por email. Que Maria nos conduza.
          </p>
        </>
      )}
      {status === "checking" && (
        <>
          <div className="overline">A verificar pagamento</div>
          <h1 className="display-heading text-3xl mt-4">Um momento…</h1>
          <p className="mt-4 text-sm text-[hsl(var(--muted-foreground))]">Tentativa {attempts}/30</p>
        </>
      )}
      {(status === "error" || status === "timeout" || status === "expired") && (
        <>
          <AlertCircle className="h-12 w-12 text-[hsl(var(--accent))] mx-auto" />
          <h1 className="display-heading text-3xl mt-6 text-[hsl(var(--primary))]">Verificação pendente.</h1>
          <p className="mt-6 text-[hsl(var(--muted-foreground))]">Se o pagamento foi bem-sucedido, receberá email de confirmação em breve. Se escolheu <strong>referência Multibanco</strong>, a confirmação chega assim que o pagamento da referência for processado. Caso contrário, contacte-nos.</p>
        </>
      )}
      <Link to="/" className="btn-outline mt-12 inline-flex">Voltar ao início</Link>
    </section>
  );
}
